import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {FlowSessionDetails} from '../../models/underwriter.model';

export interface MiniQuestionFlowState extends EntityState<FlowSessionDetails>{

}

export function createInitialState(): MiniQuestionFlowState{
    return{
        session_id: '',
        state: 'Pending',
        category_id: 0,
        item_id: '0',
        group_id: 0,
        class_id: 0,
        flow_id: 0,
        parent_flow_id: 0
    }
}

@Injectable({providedIn: 'root'})
export class MiniQuestionFlowSessionStore extends SignalEntityStore<FlowSessionDetails, MiniQuestionFlowState>{
    constructor() {
        super({name: 'mini-question-flow-session', initialState: createInitialState()});
    }
}
